import React from 'react';
import styles from '../App.module.css';
import pageStyles from './Pages.module.css';
import Wall from '../components/Wall';
import Tile from '../components/Tile';
import Hero from '../components/Hero';
import NewsletterForm from '../components/NewsletterForm';

const Home: React.FC = () => (
  <Wall>
    {/* OAKCLIFF.TECH hero — span 4, surface tone */}
    <Tile span={4} tone="surface">
      <Hero />
    </Tile>

    {/* 01 / Next Meetup — span 2, brick; fills the row beside the hero */}
    <Tile span={2} tone="brick" label="01 / Next Meetup" glyph="◆">
      <div className={styles.meetBig}>
        Thu Sep 24<br />6:00 PM
      </div>
      <div className={styles.meetSub}>Every other Thursday &middot; Lola&rsquo;s at East Dock &middot; 900 E. Clarendon Dr</div>
      <div className={pageStyles.linkRow}>
        <a className={pageStyles.linkCream} href="/meetup">
          Details + RSVP ▸
        </a>
      </div>
    </Tile>

    {/* 02 / The Community — span 3 */}
    <Tile span={3} label="02 / The Community" glyph="▸">
      <p className={styles.copy}>
        <b>Rooted in Oak&nbsp;Cliff.</b>{' '}
        Building things that matter, showing up for each other, and giving the neighborhood&rsquo;s tech scene a home.
      </p>
    </Tile>

    {/* 03 / What's Coming — span 3 */}
    <Tile span={3} label="03 / What's Coming" glyph="▸">
      <div className={styles.list}>
        <div className={styles.listItem}>
          <b>Meetups</b>
          <span>Hands-on gatherings around the neighborhood. Bring your laptop or your sketchbook.</span>
        </div>
        <div className={styles.listItem}>
          <b>Connections</b>
          <span>Real introductions between the makers, builders, and doers already in your zip code.</span>
        </div>
        <div className={styles.listItem}>
          <b>Events</b>
          <span>Demo nights, skill shares, and open-mic sessions. No speaker fees, no sponsor decks.</span>
        </div>
      </div>
    </Tile>

    {/* 04 / The Mission — span 3, olive */}
    <Tile span={3} tone="olive" label="04 / The Mission" glyph="✦">
      <p className={styles.missionCopy}>
        <b>Community tech education.</b>{' '}
        Workshops, skill shares, and mentorship that put real tools in neighborhood hands: kids, career-switchers, and curious neighbors alike.
      </p>
      <div className={pageStyles.linkRow}>
        <a className={pageStyles.linkCream} href="/education">
          More on the mission ▸
        </a>
      </div>
    </Tile>

    {/* 05 / STAY IN THE LOOP — span 3, newsletter CTA */}
    <Tile span={3} tone="ochre" label="05 / Stay in the Loop" glyph="◆">
      <NewsletterForm />
    </Tile>
  </Wall>
);

export default Home;
